<template>
  <div id="app" @click="hideSubMenu()" ref="app">
    <div class="header">
      <router-link class="logo" to="/">
        <img src="./assets/images/home/home-logo.png" alt="">
      </router-link>
      <ul class="menu">
        <li :class="showPage === item.component ? 'active' : ''" @mouseover=" item.component == 'service' ? showSubMenu = true : ''" @click=" item.component != 'service' ? jump(item.component) : serviceClickReturn($event)" v-for="(item, key) in $t('home.menu')" :key="key">
          <span>{{ firstWordtoUp(item.name) }} <img v-if="item.subMenu" src="./assets/images/home/down.png" /></span>
          <i></i>
        </li>
      </ul>
      <ul class="headerPhone">
        <li v-for="(item, key) in $t('home.phones')" :key="key">
          <span>{{ item }}</span>
        </li>
      </ul>
      <div class="languages">
        <span class="curren" @click="showLanguageList($event)">{{ currentLanguageName }}<img src="./assets/images/home/trans.png"></span>
        <ul class="listLange" v-if="languageListShowed">
          <li v-for="(language, key) in $t('home.languageList')" :key="key" @click="setLanguageCode(language.code)">
            {{ language.name }}</li>
        </ul>
      </div>
      <transition-group name="list" tag="div" class="subMenu" v-if="showSubMenu" enter-active-class="animated fadeInDown" leave-active-class="animated fadeOutUp">
        <dl class="" v-for="(sub, key) in $t('home.menu[1].subMenu')" :key="key + 1">
          <dt>{{ sub.title }}</dt>
          <dd v-for="(subMenuText, two) in sub.childrens" @click="jump(subMenuText.component, true)" :key="two + 1">
            {{ subMenuText.name }}</dd>
        </dl>
      </transition-group>
    </div>
    <div class="headerForH5">
      <img src="./assets/images/home/menuBtn.png" alt="" class="icon" @click="changeWapNav()">
      <img src="./assets/images/home/home-logo.png" alt="" class="logo">
      <div class="languages">
        <span class="curren" @click="showLanguageList($event)">{{ currentLanguageName }}<img src="./assets/images/home/trans.png"></span>
        <ul class="listLange" v-if="languageListShowed">
          <li v-for="(language, key) in $t('home.languageList')" :key="key" @click="setLanguageCode(language.code)">
            {{ language.name }}</li>
        </ul>
      </div>
      <ul class="menus" ref="wapMenus" v-if="showWapMenuBoolean" @click="hideMenu()">
        <img src="./assets/images/home/close.png" class="close" @click="hideMenu()" alt="">
        <li :class="showPage === item.component ? 'active' : ''" @click=" item.component != 'service' ? jump(item.component) : showWapSubMenu($event)" v-for="(item, key) in $t('home.menu')" :key="key">
          <span :class="isShowWapMenu ? 'active' : ''">{{ firstWordtoUp(item.name) }} <img v-if="item.subMenu" class="icon" src="./assets/images/home/down.png"></span>
          <template v-if="isShowWapMenu">
            <transition-group tag="div" enter-active-class="animated fadeInDown" leave-active-class="animated fadeOutUp">
              <dl v-for="(sub, key) in item.subMenu" :key="key + 1">
                <dt>{{ sub.title }}</dt>
                <dd v-for="(son, index) in sub.childrens" :key="index + 1" @click="jump(son.component)">{{ son.name }}
                </dd>
              </dl>
            </transition-group>
          </template>
        </li>
      </ul>
      <div class="bg" v-if="showWapMenuBoolean" @click="hideMenu()"></div>
    </div>

    <router-view />

    <div class="footer">
      <div class="codeImg">
        <div class="imgBox">
          <div class="textBox">
            <div class="text">{{ $t('home.footer.tell') }}</div>
            <div class="text">For iPhone/Android</div>
            <div class="link">www.melinked.com</div>
          </div>
          <img src="./assets/images/contact/code.png" alt="">
        </div>
      </div>
      <div class="phone">
        <img src="./assets/images/contact/phone.png" alt="">
        <!-- {{$t('home.footer.phone')}} -->
        <span>{{ $t('home.footer.p3') }}</span>
        <span>{{ $t('home.footer.p4') }}</span>
        <span>{{ $t('home.footer.p5') }}</span>
        <span>{{ $t('home.footer.p6') }}</span>
        <span>{{ $t('home.footer.p1') }}</span>
        <span>{{ $t('home.footer.p2') }}</span>
      </div>
      <div class="tips">{{ $t('contact.tips')  }}</div>
      <div class="copyRight">
        {{ $t('home.footer.copyRight') }}
      </div>
    </div>
    <img class="wapChatICON" @click="toWapChat()" ref="wapchatIcon" src="./assets/images/home/services.png" alt="">
    <!-- <iframe class="h5ImBox" :class="h5ImIFrameSrc ? 'show' : ''" :src="h5ImIFrameSrc" ></iframe> -->
  </div>
</template>
<script type="text/javascript">
import { getCurrentLanguageCode, setCurrentLanguageCode } from '@/i18n'
export default {
  data() {
    return {
      showPage: 'home',
      showSubMenu: false,
      currentCode: 1,
      currentLanguageName: '',
      languageListShowed: false,
      isShowWapMenu: false,
      showWapMenuBoolean: false,
      h5ImIFrameSrc: ''
    }
  },
  created() {
    let currPage = this.$route.name
    this.showPage = currPage ? currPage : this.showPage
    this.currentCode = getCurrentLanguageCode()
    this.getCurrentLanguageName(this.currentCode)
    try {
      if (this.$route.query && this.$route.query.lang) {
        const lang = this.$route.query.lang
        switch (lang) {
          case 'cn':
            this.currentCode != 1 && this.setLanguageCode(1)
            break
          case 'en':
            this.currentCode != 2 && this.setLanguageCode(2)
            break
        }
      }
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    // toWapChat(){
    //   // let self = this
    //   let lang = cookie.get('i18nLanguage')
    //    // self.h5ImIFrameSrc
    //   window.location.href = "https://maesinfo.melinked.com?key=A714A59BC840FA72AC7AF349A1BF4BA8&lang="+ lang +"&title=MaesInfo"
    // },
    showLanguageList(event) {
      event.stopPropagation()
      this.languageListShowed = true
    },
    changeWapNav() {
      this.showWapMenuBoolean = true
      // this.$nextTick(()=>{
      //   let heightNum = this.$refs.wapMenus.clientHeight
      //   this.$refs.app.css({'height':heightNum,'overflow': 'hidden'})
      // })
    },
    hideMenu() {
      this.showWapMenuBoolean = false
      this.isShowWapMenu = this.showWapMenuBoolean = false
    },
    showWapSubMenu(event) {
      event.stopPropagation()
      this.isShowWapMenu = !this.isShowWapMenu
    },
    setLanguageCode(code) {
      let self = this
      setCurrentLanguageCode(self, code)
      self.getCurrentLanguageName(code)
      self.languageListShowed = false
    },
    getCurrentLanguageName(code) {
      let self = this
      let list = self.$t('home.languageList')
      for (let i = 0; i < list.length; i++) {
        if (list[i].code === code) {
          self.currentLanguageName = list[i].name
          return
        }
      }
    },
    hideSubMenu() {
      this.showSubMenu = false
      this.languageListShowed = false
    },
    serviceClickReturn(event) {
      event.stopPropagation()
      return
    },
    jump(current, isService) {
      this.hideSubMenu()
      this.hideMenu()
      this.isShowWapMenu = false
      this.showPage = isService && isService != undefined ? 'service' : current
      // console.log(isService, '////');
      this.$router.push({ name: current, query: {} })
      // console.log(this.showPage);
    }
  }
}
</script>
<style lang="less">
#app {
  font-family: 'Arial', Helvetica, Avenir, sans-serif, Microsoft Yahei;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;

  .wapChatICON {
    position: fixed;
    bottom: 5rem;
    right: 1rem;
    z-index: 1000;
    cursor: pointer;
    display: none;
    // box-shadow: 0 0 1px 2px rgba(144,144,144,.4);
    border-radius: 5rem;
    width: 6rem;
  }

  .headerForH5 {
    display: none;
    flex-flow: row;
    justify-content: space-between;
    height: 60px;
    align-items: center;
    padding: 0 0.9rem;
    position: relative;
    font-size: 1.2rem;
    z-index: 10;

    .icon {
      width: 1.5rem;
      cursor: pointer;
    }

    .logo {
      width: 8rem;
    }

    .bg {
      position: fixed;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.8);
      width: 100%;
      height: 100%;
      z-index: 1100;
    }

    .menus {
      position: absolute;
      top: 0;
      left: 0;
      background: #ffffff;
      width: 100%;
      z-index: 1200;
      padding: 3.5rem 0 0.9rem;
      min-height: 100vh;
      box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.3);

      // overflow: auto;
      // padding: .9rem 0;
      .close {
        width: 1.2rem;
        height: 1.2rem;
        position: absolute;
        left: 1rem;
        top: 0.9rem;
        cursor: pointer;
      }

      li {
        text-align: left;
        line-height: 1.85rem;

        &:nth-child(2) {
          border-top: 1px solid #dedede;
        }

        &.active {
          span {
            background: #254193;
            color: #ffffff;
          }

          &:hover > span {
            color: #ffffff;
          }
        }

        &:hover > span {
          color: #254193;
        }

        span {
          padding: 0.5rem 0.9rem;
          width: 94%;
          cursor: pointer;
          display: inline-block;

          .icon {
            float: right;
            width: 1rem;
            margin: 0.8rem 0 0;
          }

          &:active {
            .icon {
              transform: rotate(180deg);
              -ms-transform: rotate(180deg);
              /* IE 9 */
              -moz-transform: rotate(180deg);
              /* Firefox */
              -webkit-transform: rotate(180deg);
              /* Safari 和 Chrome */
              -o-transform: rotate(180deg);
              /* Opera */
            }
          }
        }

        dl {
          margin: 0;
          line-height: 2.5rem;

          dt {
            text-indent: 1.25rem;
            color: #254193;
          }

          dd {
            cursor: pointer;

            &:hover {
              color: #254193;
            }
          }
        }
      }
    }

    .languages {
      // position: absolute;
      // right:1.5rem;
      margin-right: 0.2rem;
      display: flex;
      flex-flow: column;

      .curren {
        cursor: pointer;

        img {
          margin: 0 0 0 0.25rem;
        }
      }

      // font-size: 1.25rem;
      .listLange {
        // display: none;
        position: absolute;
        top: 50px;
        z-index: 1000;
        background: #ffffff;
        padding: 0.5rem 0.9rem;
        display: flex;
        flex-flow: column;
        right: 1rem;
        width: auto;
        min-width: 80px;
        box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.2);

        li {
          line-height: 2.2rem;
          cursor: pointer;

          &:hover {
            color: #999999;
          }
        }

        &.active {
          display: inline-block;
        }
      }
    }
  }

  // color: #2c3e50;
  .header {
    display: flex;
    flex-flow: row;
    align-items: center;
    height: 62px;
    padding: 0 0.9rem;

    .logo {
      margin-left: 0.98rem;
    }

    .list-item {
      display: inline-block;
      margin-right: 10px;
    }

    .list-enter-active,
    .list-leave-active {
      transition: all 3s;
    }

    .list-enter,
    .list-leave-to

    /* .list-leave-active for below version 2.1.8 */ {
      opacity: 0;
      transform: translateY(30px);
    }

    .languages {
      position: absolute;
      right: 1.5rem;
      display: flex;
      flex-flow: column;

      .curren {
        cursor: pointer;

        img {
          margin: 0 0 0 0.25rem;
        }
      }

      // font-size: 1.25rem;
      .listLange {
        // display: none;
        position: absolute;
        top: 35px;
        z-index: 1000;
        background: #ffffff;
        padding: 0.5rem 0.9rem;
        display: flex;
        flex-flow: column;
        right: -1rem;
        width: auto;
        min-width: 80px;
        box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.2);

        li {
          line-height: 2.2rem;
          cursor: pointer;

          &:hover {
            color: #999999;
          }
        }

        &.active {
          display: inline-block;
        }
      }
    }

    .subMenu {
      position: absolute;
      width: 88%;
      top: 62px;
      // display: none;
      // margin: 5.4rem auto;
      border-top: 1px solid #dedede;
      padding: 0 0 2.2rem 0;
      left: 6%;
      background: #ffffff;
      z-index: 1000;
      display: flex;
      flex-flow: row;
      flex-wrap: wrap;
      justify-content: space-around;

      &.active {
        display: flex;
      }

      &.hidden {
        display: none;
      }

      dl {
        margin: 0;
        padding: 0;
        text-align: left;
        line-height: 1.8rem;

        dd,
        dt {
          margin: 0;
          padding: 0;
        }

        dt {
          color: #254193;
          font-weight: 600;
          font-size: 1.5rem;
          margin: 0.9rem 0 0.4rem;
        }

        dd {
          font-size: 0.98rem;
          color: #000000;
          cursor: pointer;

          &:hover {
            text-decoration: underline;
            color: #254193;
          }
        }
      }
    }

    .menu {
      display: flex;
      flex-flow: row;
      margin-left: 0.6rem;

      li {
        padding: 0 0.7rem;
        display: flex;
        flex-flow: column;
        margin-top: 8px;
        cursor: pointer;

        span {
          // padding:0 .5rem;
          img {
            width: 0.8rem;
            object-fit: cover;
            margin: 0 0.25rem;
          }
        }

        i {
          width: 100%;
          height: 4px;
          margin-top: 4px;
          border-radius: 3rem;
          // display: none;
          background: #fff;
        }

        &.active > i,
        &:hover > i {
          display: block;
          background: #254193;
        }
      }
    }
    .headerPhone {
      position: absolute;
      right: 6rem;
      display: flex;
      color: #5066a7;
      font-weight: 600;
      font-size: 0.7rem;
      align-items: center;
      li {
        margin-right: 10px;
      }
    }
  }

  .h5ImBox {
    display: none;
    z-index: 2000;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    position: fixed;
    background: #ffffff;
    border: 0;
    top: 0;
    left: 0;

    &.show {
      display: block;
    }
  }

  .footer {
    display: flex;
    flex-flow: column;
    justify-content: center;
    margin-top: 2.5rem;

    .codeImg {
      margin-bottom: 57px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 0 27px;
      box-sizing: border-box;

      .imgBox {
        width: 119px;
        height: 119px;
        position: relative;

        .textBox {
          position: absolute;
          width: 208px;
          height: 98px;
          background: #254193;
          border-radius: 8px;
          left: -225px;
          top: 50%;
          margin-top: -49px;
          padding: 14px 20px 11px;
          box-sizing: border-box;
          color: #fff;
          text-align: left;

          &::after {
            content: '';
            position: absolute;
            top: 50%;
            margin-top: -10px;
            right: -10px;
            width: 20px;
            height: 20px;
            text-align: center;
            transform: rotate(45deg);
            background: #254193;
          }

          .text {
            font-size: 16px;
            margin-bottom: 4px;
          }

          .link {
            font-size: 14px;
            color: #bfbfbf;
            margin-top: 7px;
          }
        }

        img {
          width: 100%;
        }
      }
    }

    .phone {
      font-size: 16px;
      color: #666;
      padding: 1rem;
      padding-bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      img {
        width: 24px;
        margin-right: 12px;
      }

      span {
        margin-right: 4px;
      }
    }
    .tips {
      font-size: 0.8rem;
      line-height: 30px;
      color: #999;
      border-bottom: 1px solid #dddddd;
    }
    .copyRight {
      font-size: 0.8rem;
      line-height: 36px;
      color: #999;
    }
  }
}
</style>
